<template>
    <v-layout id="statspage">
        <v-flex v-if="!isFetching">
             <v-btn @click="setYear('prev')" small icon>
                        <v-icon>arrow_left</v-icon>  
                    </v-btn>
                    {{year}}
                    <v-btn @click="setYear('next')" small icon>
                        <v-icon>arrow_right</v-icon>  
                    </v-btn>
            <table>
                <thead>
                    <th>Month</th>
                    <th colspan="2" v-for="s in Object.keys(stats)">{{s}}</th>
                    
                </thead>
                <tbody>
                    <tr>
                        <td>&nbsp;</td>
                        <slot v-for="s in Object.keys(stats)">
                            <td>Eco</td>
                            <td>Mobile</td>
                        </slot>
                    </tr>
                    <tr v-for="m in Object.keys(months)">
                        <td>{{months[m]}}</td>
                        <slot v-for="s in Object.keys(stats)">
                            <td>{{getStats(s, m).eco}}</td>
                            <td>{{getStats(s, m).stats}}</td>
                        </slot>
                    </tr>
                </tbody>
                
            </table>
        </v-flex>
    </v-layout>
</template>
<script>
    export default {
        name: 'StatsIndex',
        data()
        {
            return {}
        },

        created() {

            this.$store.dispatch('settings/setToolbarHidden', true)
            
        },

        beforeRouteUpdate(to, from, next)
        {

            this.$store.dispatch('stats/index', to.query.year)
            next();
        },

        beforeRouteLeave(to, from, next)
        {
           this.$store.dispatch('settings/setToolbarHidden', false)
           next();
        },



        methods: {

            setYear(action)
            {
                let year = this.year;

                switch(action)
                {
                    case 'prev': year--; break;
                    case 'next': year++; break;
                }

                this.year = year;
            },

            getStats(s, m)
            {
                let t = {eco: '-', stats: '-'};
                if(typeof this.stats[s][m] !== 'undefined')
                {
                    if(typeof this.stats[s][m].eco !== 'undefined')
                    {
                        //if(this.stats[s][m].eco === 0){this.stats[s][m].eco = '0'}
                        t.eco  = this.stats[s][m].eco;
                    }

                    if(typeof this.stats[s][m].stats !== 'undefined')
                    {
                        //if(this.stats[s][m].stats === 0){this.stats[s][m].stats = '0'}
                        t.stats = this.stats[s][m].stats
                    }
                }

                
                return t;
            }
        },

        mounted() {
            this.$nextTick(() => {

                let year = (new Date()).getFullYear();
                if(this.$route.query.year)
                {
                    year = this.$route.query.year;
                }
              

                this.$store.dispatch('stats/index', year);
            })
        },

        computed: {

            year: {
                get()
                {
                    let y  = (new Date()).getFullYear();
                    if(this.$route.query.year){
                        y = this.$route.query.year;
                    }

                    return y;
                },

                set(value)
                {
                    this.$router.push({name: 'statsIndex', query: {year: value}})
                }
            },

            isFetching: {
                get()
                {
                    return this.$store.getters['stats/isFetching'];
                }
            },

            months: {
                get()
                {
                    return this.$store.getters['stats/months']
                }
            },

            stats: {
                get()
                {
                    return this.$store.getters['stats/stats']
                }
            }
        }
    }
</script>


    
<style>
    /*nav{
        display: none;
    } */

    body, .v-content__wrap, .v-content, .layout {
        background-color: #fff !important;
    }

    #statspage{
        backgroud-color:#fff !important;
    }

    table{
        width: 100%;
    }

</style>


